jQuery(document).ready(function($) {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function() {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // modal-form pro patičku
  $('footer #menu-footer-menu-zivot-ve-finidru .footer-cv-form a').addClass(
    'modal--show'
  );
  $('footer #menu-footer-menu-zivot-ve-finidru .footer-cv-form a').attr(
    'data-rel',
    'form-job'
  );

  // úprava menu
  if ($('.nav').length) {
    $('.menu-item-has-children > a').on('click', function(event) {
      var clientDeviceIsMobile = window.innerWidth <= 800;

      if (clientDeviceIsMobile) {
        event.preventDefault();

        if (
          $(this)
            .parent()
            .hasClass('is-open')
        ) {
          $('.menu-item-has-children.is-open').toggleClass('is-open');
        } else {
          $('.menu-item-has-children.is-open').removeClass('is-open');
          $(this)
            .parent()
            .addClass('is-open');
        }
      }
    });

    $('.menu-item-has-children').on({
      // uzivatel najel mysi na polozku, ktera ma submenu
      mouseenter: function() {
        var clientDeviceIsMobile = window.innerWidth <= 800;

        if (!clientDeviceIsMobile) {
          $('.is-open').removeClass('is-open');
          $(this).addClass('is-open');
        }
      }
    });

    $('.header').on({
      // uzivatel vyjel mysi z hlavicky
      mouseleave: function() {
        var clientDeviceIsMobile = window.innerWidth <= 800;

        if (!clientDeviceIsMobile) {
          $('.is-open').removeClass('is-open');
        }
      }
    });
  }

  // otevření menu
  if ($('.nav').length) {
    showMenu = $('.content').data('menu');
    showSubMenu = $('.content').data('submenu');
    if (showMenu > 0) {
      showMenu = '#menu-item-' + parseInt(showMenu);
      $(showMenu).addClass('current_page_parent');
    }
    if (showSubMenu > 0) {
      showSubMenu = '#menu-item-' + parseInt(showSubMenu);
      $(showSubMenu).addClass('current_page_item');
    }
    var clientDeviceIsMobile = window.innerWidth <= 800;

    if (!clientDeviceIsMobile) {
      $('.current_page_item')
        .parent()
        .show('slow');
    }
  }

  // záložky
  if ($('.tabs').length) {
    $('.tabs__content > div')
      .not('.is-active')
      .hide();

    // po kliknutí zobrazíme příslušný tab
    $('.tabs__name').on('click', function(event) {
      event.preventDefault();

      var target = $(this).attr('href');

      $('.tabs__content > .is-active')
        .removeClass('is-active')
        .hide();

      $(target)
        .addClass('is-active')
        .show();

      $('.tabs__name').removeClass('is-active');
      $(this).addClass('is-active');
    });
  }

  // benefity
  if ($('.benefits').length) {
    $('.benefits__content > div')
      .not('.is-active')
      .hide();

    // po kliknutí zobrazíme příslušný tab
    $('.benefits__name').on('click', function(event) {
      event.preventDefault();

      var target = $(this).attr('href');

      $('.benefits__content > .is-active')
        .removeClass('is-active')
        .hide();

      $(target)
        .addClass('is-active')
        .show();

      $('.benefits__name').removeClass('is-active');
      $(this).addClass('is-active');
    });
  }

  // akordeon
  if ($('.accordion').length) {
    // po kliknutí vyměníme class
    $('.accordion__item').on('click', function(event) {
      event.preventDefault();

      if (
        !$(this)
          .parent()
          .hasClass('is-open')
      ) {
        $(this)
          .parent()
          .slideDown('fast', function() {
            $(this).addClass('is-open');
          });
      } else {
        $(this)
          .parent()
          .slideUp('fast', function() {
            $(this).removeClass('is-open');
          });
      }
    });
  }

  // vyhledávací pole
  if ($('.nav-helper__option--search').length) {
    $('.nav-helper__option--search').on('click', function(event) {
      event.preventDefault();

      if ($('.nav-helper__search').hasClass('is-open')) {
        $('.nav-helper__search').slideUp('fast', function() {
          $(this).removeClass('is-open');
        });
      } else {
        $('.nav-helper__search').slideDown('fast', function() {
          $(this).addClass('is-open');
        });
      }
    });
  }

  // modal okna
  if ($('.modal').length) {
    // otevření okna
    $('.modal--show').on('click', function() {
      // zjištění ID okna z atributu rel
      var modalName = '#' + $(this).data('rel');
      var modalBody = modalName + ' .modal__body';

      // otevření konkrétního okna
      $(modalName).show();

      // zjištění výšky okna
      var modalHeight = $(modalBody).outerHeight();

      // pokud je výška obrazovky menší než okno, resetuje se pozice
      if (modalHeight > window.innerHeight) {
        $(modalName).addClass('modal--reset');
      }
    });

    // zavření okna
    $('.modal__close').on('click', function() {
      $(this)
        .closest('.modal')
        .hide();
      return false;
    });
  }

  // custom select (Selectric)
  if ($('select').length) {
    $('select').selectric();
  }

  // slider (Slick)
  if ($('.slider--index').length) {
    $('.slider--index').slick({
      dots: false,
      speed: 500,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      fade: true,
      cssEase: 'linear',
      zIndex: 500,
      prevArrow:
        "<button type='button' class='slick-prev pull-left'> < </button>",
      nextArrow:
        "<button type='button' class='slick-next pull-right'> > </button>"
    });
  }

  // slider příběhy zaměstnanců (Slick)
  if ($('.experience').length) {
    // hlavní slide
    $('.experience__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      speed: 500,
      zIndex: 500,
      dots: false,
      autoplay: true
    });

    // po přechodu na další slide
    $('.experience__slider').on('beforeChange', function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      $('.experience__nav .experience__menu').removeClass('is-active');
      $('.experience__nav .experience__menu')
        .eq(nextSlide)
        .addClass('is-active');
    });

    // menu slidů
    $('.experience__nav .experience__menu')
      .first()
      .addClass('is-active');
    $('.experience__nav .experience__menu').click(function(e) {
      e.preventDefault();
      slideIndex = $(this).index();
      slideIndex = parseInt(slideIndex);
      $('.experience__slider').slick('slickGoTo', slideIndex);
    });
  }

  // zobrazení a zvýraznění menu pokud bude detail aktuality
  if ($('.js-single-news').length) {
    $('#menu-item-90')
      .addClass('current_page_item')
      .addClass('current_page_parent');
    $('#menu-item-188').addClass('current-menu-item');
  }

  // zobrazení a zvýraznění menu aktualit v jazykových mutacích
  if ($('.js-active-news').length) {
    $('#menu-item-188').addClass('current_page_item');
  }

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav__switcher-wrapper').hasClass('is-open')) {
      $('.nav__switcher-wrapper').removeClass('is-open');
    } else {
      $('.nav__switcher-wrapper').addClass('is-open');
    }

    // otevřeme produktové menu
    if ($('.nav').hasClass('is-open')) {
      $('.nav').removeClass('is-open');
    } else {
      $('.nav').addClass('is-open');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav__switcher-wrapper, .nav').removeClass('is-open');
  }
  // spouštěč
  $('.nav__switcher-wrapper').on('click', function() {
    switchMenu();
  });

  // slovníček otevření z linku
  var dictionary = $('section.container .accordion:last-child');
  var url = window.location.href;

  if (url.indexOf('dict') > -1) {
    dictionary.addClass('is-open');
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: dictionary.offset().top
      },
      500
    );
  }

  var iform = $('#inquiry-form');

  if (url.indexOf('potvrdbut') > -1) {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: iform.offset().top
      },
      500
    );
  }

  // script for Press page
  $('#ba__slider').on('input change', e => {
    const sliderPos = e.target.value;
    // Update the width of the before image
    $('.ba__img--before').css('width', `${sliderPos}%`);
    // Update the position of the slider button
    $('.ba__slider__button').css('left', `calc(${sliderPos}% - 18px)`);
  });
});
